import Intro from "./components/intro/Intro";
import About from "./components/about/About";
import ProjectList from "./components/projectList/ProjectList";
import Skills from "./components/skills/Skills";
import Contact from "./components/contact/Contact";
import Toggle from "./components/toggle/Toggle";
import { ThemeContext } from "./context";
import { useContext } from "react";
import Education from "./components/education/Education";
import { Footer } from "./footer/Footer";

const App = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      style={{
        backgroundColor: darkMode ? "#0F152F" : "white",
        color: darkMode ? "white" : "black",
      }}
    >
      {/* #222 - old dark color */}
      <Toggle />
      <Intro />
      <About />
      <Education />
      <Skills />
      <ProjectList />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
